import React from 'react';
import classNames from 'classnames';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import ScrollToTop from "react-scroll-to-top";
import { swCookies, subDomains} from '../../lib/constants';


import './BackToTop.scss';
import SvgIcon from '../SvgIcon';

const BackToTop = ({isRtl, cookies, isLoggedIn, t, isFetchingMe, isConsentGiven, subDomain}) => {
  const baseClassName = 'pb-back-to-top';

  let shouldDisplayCookieConsent = (isLoggedIn ? !isConsentGiven : !cookies.get(swCookies.consent)) && subDomain !== subDomains.ddl && subDomain !== subDomains.gd

  if (isFetchingMe) {
    shouldDisplayCookieConsent = false
  }

  const classes = {
    [baseClassName]: true,
    [`${baseClassName}__content`]: true,
    [`${baseClassName}__rtl-btn`]: isRtl,
    [`${baseClassName}__show-notice`]: shouldDisplayCookieConsent,
    [`${baseClassName}__hide-notice`]: !shouldDisplayCookieConsent,
  };

  return (
    <ScrollToTop smooth 
      top={1500}
      component={<span className={`${baseClassName}__wrapper`}> {!isRtl && <SvgIcon name="chevron-left" />}  <span className={`${baseClassName}__wrapper--text`} >{t("global.back-to-top")}</span> {isRtl && <SvgIcon name="chevron-left" />}</span>}
      className={classNames(classes)}
    />
  )
}

BackToTop.propTypes = {
  cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(BackToTop)



// WEBPACK FOOTER //
// ./src/components/BackToTop/BackToTop.jsx